var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlob7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 221,
    viewBox: "0 0 400 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M208.916 55.2121C171.057 49.7733 106.911 24.9118 71.3783 35.7892C35.8459 46.6666 21.9297 72.3054 4.15894 122.81C-13.6118 173.314 29.6638 197.398 56.7063 211.384C83.7488 225.369 141.697 231.585 176.465 173.312C211.234 115.04 233.641 132.91 263.774 169.427C293.907 205.945 334.084 175.643 364.99 132.91C395.895 90.1769 417.529 22.5807 380.443 5.48744C343.356 -11.6059 324.812 14.8111 297.77 35.7892C270.727 56.7674 246.776 60.6508 208.916 55.2121Z",
    fill: "#E28861",
    style: {
      mixBlendMode: "lighten"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob7);
export default __webpack_public_path__ + "static/media/blob7.9cc799126cc5caed884e83fe1dadef79.svg";
export { ForwardRef as ReactComponent };